import "@/index.css";
import { AuthProvider } from "./core/auth/contexts/AuthProvider";
import { AppRouter } from "./core/routing/AppRouter";
import { useNavigationIdentity } from "./core/routing/NavigationContext";
import { AppRoutes } from "./core/routing/routes";
import { ProfileProvider } from "./features/profile/contexts/ProfileProvider";

function AppContent() {
  const onIdentityChange = useNavigationIdentity();
  return (
    <AuthProvider onIdentityChange={onIdentityChange}>
      <ProfileProvider>
        <AppRoutes />
      </ProfileProvider>
    </AuthProvider>
  );
}

export default function App() {
  return (
    <AppRouter>
      <AppContent />
    </AppRouter>
  );
}
